<template>
  <v-col cols="12" xl="6" lg="6" md="10" sm="12" xs="12" class="mt-0 mb-0">
    <v-card>
      <v-tabs v-model="tab" centered show-arrows center-active class="ma-0 pa-0">
        <v-tabs-slider color="#1685c9" class="ma-0 pa-0"></v-tabs-slider>
        <v-tab active-class="#1685c9--text" href="#tab-1" style="width: 100%">
          <v-icon left>mdi-usb</v-icon>
          {{ isOnMobile ? (isOnAndroid ? "Bluetooth" : "Сериен порт/USB") : "Свързване по Сериен порт/USB" }}
        </v-tab>

        <v-tab active-class="#1685c9--text" href="#tab-2" style="width: 100%">
          <v-icon left>mdi-lan</v-icon>
          {{ isOnMobile ? "LAN/WIFI" : "Свързване по LAN/WIFI" }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" style="width: 100%; height: 100%" class="py-2">
        <v-tab-item value="tab-1">
          <v-form ref="formConnectCOM" v-model="valid" lazy-validation>
            <v-row class="pa-2">
              <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12" class="ma-0">
                <v-combobox v-model="device.serialPort" :items="isOnMobile ? [] : serialPorts" :label="isOnAndroid ? 'Сериен номер на ФУ' : 'Сериен порт'" outlined dense required hide-details :rules="requiredRule"></v-combobox>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12" class="ma-0">
                <v-combobox v-model="device.baudRate" :items="baudRates" label="Скорост" outlined dense aria-required required hide-details :rules="requiredRule"></v-combobox>
              </v-col>
            </v-row>
          </v-form>
          <v-alert v-if="messageSerial != null" border="top" colored-border :type="color" elevation="1" dense class="ml-2 mr-2 mt-0 mb-0">
            <span>{{ messageSerial }}</span>
          </v-alert>
          <v-row justify="center">
            <v-btn class="ma-2" tile :color="isInDarkMode ? '' : 'blue lighten-4'" @click="findDevice">
              <v-icon color="#1685c9">mdi-magnify</v-icon>
              <span>Търсене</span>
            </v-btn>
            <v-btn class="ma-2" tile :color="isInDarkMode ? '' : 'blue lighten-4'" @click="connect('com')">
              <v-icon color="#1685c9">mdi-lan-connect</v-icon>
              <span>Свързване</span>
            </v-btn>
          </v-row>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-form ref="formConnectTCP" v-model="valid" lazy-validation>
            <v-row class="pl-2 pr-2">
              <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12" class="mt-0 mb-0">
                <v-text-field v-model="device.ipAddress" outlined dense :label="isOnMobile ? 'IP адрес на ФУ' : 'IP адрес на ФУ'" placeholder="Пр. - 192.168.0.1" required hide-details :rules="requiredRule"></v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6" sm="12" xs="12" class="mt-0 mb-0">
                <v-text-field v-model="device.password" outlined dense label="Мрежова парола" placeholder="Пр. - 1234" required hide-details :rules="requiredRule"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-alert v-if="messageLan != null" border="top" colored-border :type="color" elevation="1" dense class="ml-2 mr-2">
            <span>{{ messageLan }}</span>
          </v-alert>
          <v-row justify="center">
            <v-btn class="ma-2" tile :color="isInDarkMode ? '' : 'blue lighten-4'" @click="connect('tcp')">
              <v-icon color="#1685c9">mdi-lan-connect</v-icon>
              <span>Свързване</span>
            </v-btn>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-col>
</template>

<script>
import Const from "../constants";

export default {
  props: {},
  data() {
    return {
      valid: true,
      tab: null,
      device: {
        isOnSerialPort: true,
        serialPort: "COM3",
        baudRate: "115200",
        ipAddress: null,
        tcpPort: 8000,
        password: null,
      },
      color: null,
      messageSerial: null,
      messageLan: null,
      requiredRule: [(v) => !!v || "Задължително поле!"],
    };
  },
  computed: {
    serialPorts() {
      return Const.SerialPortNames;
    },
    baudRates() {
      return Const.BaudRates;
    },
  },
  methods: {
    async findDevice() {
      this.fp.isSearchingForDevice = true;
      setTimeout(async () => {
        try {
          var found = await this.fp.ServerFindDevice();
          if (found != null) {
            this.device.serialPort = found.serialPort;
            this.device.baudRate = found.baudRate;
            this.color = "success";
            this.messageSerial = `Открито устройство на: ${this.device.serialPort} и скорост: ${this.device.baudRate}`;
          } else {
            this.color = "warning";
            this.messageSerial = "Не е открито устройство!";
          }
        } catch (ex) {
          /** ignored */
        }
        this.fp.isSearchingForDevice = false;
      }, 500);
    },
    async connect(connectionType) {
      try {
        if ((connectionType == "com" && this.$refs.formConnectCOM.validate()) || (connectionType == "tcp" && this.$refs.formConnectTCP.validate())) {
          this.fp.isSearchingForDevice = true;
          switch (connectionType) {
            case "com":
              localStorage.setItem(Const.DeviceIsWorkingOnSerialPort, true);
              localStorage.setItem(Const.DeviceSerialPortName, this.device.serialPort);
              localStorage.setItem(Const.DeviceBaudRate, this.device.baudRate);
              break;
            case "tcp":
              localStorage.setItem(Const.DeviceIsWorkingOnSerialPort, false);
              localStorage.setItem(Const.DeviceIPAddress, this.device.ipAddress);
              localStorage.setItem(Const.DevicePassword, this.device.password);
              break;
          }
          await this.fp.connect();
          this.color = "success";
        }
      } catch (ex) {
        this.color = "warning";
        var msg2 = "Неуспешна връзка с фискалното устройство!\n" + ex.message;
        if (connectionType == "com") {
          this.messageSerial = msg2;
        } else {
          this.messageLan = msg2;
        }
        this.fp.handleException(ex);
      }
    },
  },
  mounted() {
    this.device.isOnSerialPort = (localStorage.getItem(Const.DeviceIsWorkingOnSerialPort) || "true") == "true";
    this.device.ipAddress = localStorage.getItem(Const.DeviceIPAddress);
    this.device.password = localStorage.getItem(Const.DevicePassword);
    this.device.serialPort = localStorage.getItem(Const.DeviceSerialPortName);
    this.device.baudRate = localStorage.getItem(Const.DeviceBaudRate);
  },
};
</script>

<style>
input:placeholder-shown {
  padding-left: 5px;
  font-size: 0.8em;
}
</style>
